// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--cdLFt","btn":"styles-scoped__btn--ZynYC","formContainer":"styles-scoped__formContainer--jsf_W","icon":"styles-scoped__icon--nqL6R"};